import {FormConfig} from "../../form/form.config";
import {FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FormModel} from "../../form/form.model.abstract";
import {FormModelText} from "../../form/form.model.text";
import {FormModelSelect} from "../../form/form.model.select";
import {MinicheckContants} from "../minicheck.contants";
import {FormModelRadio} from "../../form/form.model.radio";
import {FormModelNumber} from "../../form/form.model.number";
import {FormModelSlider} from "../../form/form.model.slider";
import {FormModelCheckboxes} from "../../form/form.model.checkboxes";

/**
 * Configuration for the input fields of each minicheck action
 * @inheritDoc
 */
export class EingabeForm extends FormConfig {

  eingabeform: EingabeForm;

  /**
   * holds the action name of the minicheck
   */
  actionName: string;

  /**
   * @inheritDoc
   * @protected
   */
  protected fields: FormModel[] = [
    new FormModelText('yearly_electricity_consumption', [Validators.required, Validators.min(MinicheckContants.ELECTRICITY_CONSUMPTION_MIN), Validators.max(MinicheckContants.ELECTRICITY_CONSUMPTION_MAX)], 'kwh', null, false, 'number'),
    new FormModelText('distance_traveled', [Validators.required, Validators.min(MinicheckContants.DISTANCE_KM_MIN), Validators.max(MinicheckContants.DISTANCE_KM_MAX)], 'km', null, false, 'number'),
    new FormModelText('number_tours_per_week', [Validators.required, Validators.min(MinicheckContants.DISTANCE_KM_MIN), Validators.max(MinicheckContants.DISTANCE_KM_MAX)], null, null, false, 'number'),
    new FormModelText('distance_traveled_public', [Validators.required, Validators.min(MinicheckContants.DISTANCE_KM_MIN), Validators.max(MinicheckContants.DISTANCE_KM_MAX_PUBLIC)], 'km', null, false, 'number'),
    new FormModelText('number_tours_per_week_public', [Validators.required, Validators.min(MinicheckContants.DISTANCE_KM_MIN), Validators.max(MinicheckContants.TOURS_MAX_PUBLIC)], null, null, false, 'number'),
    new FormModelSelect('current_bio_product_proportion', MinicheckContants.PERCENT_OPTIONS, [Validators.required], '%', '', true),
    new FormModelSelect('target_bio_product_proportion', MinicheckContants.PERCENT_OPTIONS, [Validators.required], '%', '', false),
    new FormModelSelect('current_bio_nutrition_style', MinicheckContants.NUTRITION_STYLE_OPTIONS, [Validators.required], null, '', false),
    new FormModelSelect('current_nutrition_style', MinicheckContants.NUTRITION_STYLE_OPTIONS, [Validators.required], null, '', true),
    new FormModelSelect('target_nutrition_style', MinicheckContants.NUTRITION_STYLE_OPTIONS, [Validators.required], null, '', false),
    new FormModelNumber('number_of_migrators', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_MIGRATORS_MIN), Validators.max(MinicheckContants.NUMBER_OF_MIGRATORS_MAX)], null, 1, false),
    new FormModelNumber('number_of_people_on_the_household', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_PEOPLE_MIN), Validators.max(MinicheckContants.NUMBER_OF_PEOPLE_MAX)], null, 1, false),
    new FormModelText('number_of_drying_per_week', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_DRYING_MIN), Validators.max(MinicheckContants.NUMBER_OF_DRYING_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_cloth_washing_with_60c_per_week', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_CLOTH_WASHING_MIN), Validators.max(MinicheckContants.NUMBER_OF_CLOTH_WASHING_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_cloth_washing_per_week', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_CLOTH_WASHING_MIN), Validators.max(MinicheckContants.NUMBER_OF_CLOTH_WASHING_MAX)], null, null, false, 'number'),
    new FormModelSelect('energy_source', MinicheckContants.ENERGY_SOURCE_OPTIONS, [Validators.required], null, '', false),
    new FormModelText('number_per_week_bathing', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_BATHS_MIN), Validators.max(MinicheckContants.NUMBER_OF_BATHS_MAX)], null, null, false, 'number'),
    new FormModelText('showers_per_week', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_SHOWERS_MIN), Validators.max(MinicheckContants.NUMBER_OF_SHOWERS_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_usages_month', [Validators.required, Validators.min(MinicheckContants.MICROWAVE_HEATING_MIN), Validators.max(MinicheckContants.MICROWAVE_HEATING_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_defrost_per_week', [Validators.required, Validators.min(MinicheckContants.WEEKLY_DEFROST_MIN), Validators.max(MinicheckContants.WEEKLY_DEFROST_MAX)], null, null, false, 'number'),
    new FormModelRadio('fridge_energy_class', MinicheckContants.FRIDGE_ENERGY_CLASS_OPTIONS, [Validators.required], null, null, false),
    new FormModelRadio('fridge_type', MinicheckContants.FRIDGE_TYPE_OPTIONS, [Validators.required], null, null, false),
    new FormModelText('room_size', [Validators.required, Validators.min(MinicheckContants.ROOM_SIZE_MIN), Validators.max(MinicheckContants.ROOM_SIZE_MAX)], 'm2', null, false, 'number'),
    new FormModelSelect('building_year', MinicheckContants.BUILDING_YEAR_OPTIONS, [Validators.required], null, '', true),
    new FormModelText('living_area', [Validators.required, Validators.min(MinicheckContants.LIVING_AREA_MIN), Validators.max(MinicheckContants.LIVING_AREA_MAX)], 'm2', null, false, 'number'),
    new FormModelText('number_of_rooms_in_the_flat', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_ROOMS_MIN), Validators.max(MinicheckContants.NUMBER_OF_ROOMS_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_rooms_that_are_ventilated', [Validators.required, Validators.min(MinicheckContants.NUMBER_OF_ROOMS_MIN), Validators.max(MinicheckContants.NUMBER_OF_ROOMS_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_hands_washing_per_day', [Validators.required, Validators.min(MinicheckContants.NUMBER_HAND_WASH_MIN), Validators.max(MinicheckContants.NUMBER_HAND_WASH_MAX)], null, null, false, 'number'),
    new FormModelText('meals_cooked_per_week', [Validators.required, Validators.min(MinicheckContants.DO_PER_WEEK_MIN), Validators.max(MinicheckContants.DO_PER_WEEK_MAX)], null, null, false, 'number'),
    new FormModelText('water_heated_each_day', [Validators.required, Validators.min(MinicheckContants.DAILY_HEATED_WATER_MIN), Validators.max(MinicheckContants.DAILY_HEATED_WATER_MAX)], 'liter', null, false, 'number'),
    new FormModelText('usages_per_week', [Validators.required, Validators.min(MinicheckContants.DO_PER_WEEK_MIN), Validators.max(MinicheckContants.DO_PER_WEEK_MAX)], null, null, false, 'number'),
    new FormModelText('number_of_usages_per_month', [Validators.required, Validators.min(MinicheckContants.USAGE_PER_MONTH_MIN), Validators.max(MinicheckContants.USAGE_PER_MONTH_MAX)], null, null, false, 'number'),
    new FormModelText('washing_dishes_per_week', [Validators.required, Validators.min(MinicheckContants.DO_PER_WEEK_MIN), Validators.max(MinicheckContants.DO_PER_WEEK_MAX)], null, null, false, 'number'),
    new FormModelSlider('current_living_area', [Validators.required], MinicheckContants.HOUSING_SUFFICIENCY_LIVING_AREA_MIN, MinicheckContants.HOUSING_SUFFICIENCY_LIVING_AREA_MAX, 1, 'm2', MinicheckContants.HOUSING_SUFFICIENCY_LIVING_AREA_AVERAGE, false),
    new FormModelSelect('current_energy_source', MinicheckContants.ENERGY_SOURCE_OPTIONS_BUILDING, [Validators.required], null, '', false),
    new FormModelSlider('new_living_area', [Validators.required], MinicheckContants.HOUSING_SUFFICIENCY_LIVING_AREA_MIN, MinicheckContants.HOUSING_SUFFICIENCY_LIVING_AREA_MAX, 1, 'm2', MinicheckContants.HOUSING_SUFFICIENCY_LIVING_AREA_AVERAGE, false),
    new FormModelSelect('new_energy_source', MinicheckContants.ENERGY_SOURCE_OPTIONS_BUILDING, [Validators.required], null, '', false),
    new FormModelRadio('building_type', MinicheckContants.BUILDING_TYPE_OPTIONS, [Validators.required], null, null, false),
    new FormModelSelect('building_location', MinicheckContants.BUILDING_LOCATION_OPTIONS, [Validators.required], null, '', false),
    new FormModelRadio('roof_type', MinicheckContants.ROOF_TYPE_OPTIONS, [Validators.required], null, null, false),
    new FormModelCheckboxes('insulation_measure', MinicheckContants.INSULATION_MEASURE_OPTIONS, [], null, null, false),
  ];

  /**
   * @inheritDoc
   * @protected
   */
  protected groups = {
    'switch_to_green_electricity': ['yearly_electricity_consumption'],
    'travel_with_public_transport': ['distance_traveled_public', 'number_tours_per_week_public'],
    'travel_with_bike': ['distance_traveled', 'number_tours_per_week'],
    'buy_more_bio_products': ['current_bio_product_proportion', 'target_bio_product_proportion', 'current_bio_nutrition_style'],
    'change_nutrition_style': ['current_nutrition_style', 'target_nutrition_style', 'number_of_migrators'],
    'hang_dry_and_dont_tumble_dry_the_laundry': ['number_of_people_on_the_household'],
    'spin-dry_the_laundry_thoroughlys': ['number_of_drying_per_week'],
    'use_laundry_with_40c': ['number_of_cloth_washing_with_60c_per_week'],
    'dont_use_pre-wash_in_laundry': ['number_of_cloth_washing_per_week'],
    'use_rinse_hold_for_toilet': ['number_of_people_on_the_household'],
    'shower_instead_of_bath': ['energy_source', 'number_per_week_bathing'],
    'use_a_water_saving_shower_head': ['showers_per_week', 'energy_source'],
    'mikrowave_instead_of_oven': ['number_of_usages_month'],
    'thaw_frozen_foods_on_air': ['number_of_defrost_per_week'],
    'do_not_adjust_refrigerator_too_cold': ['fridge_energy_class', 'fridge_type'],
    'reduce_room_temperature': ['room_size', 'building_year', 'energy_source'],
    'properly_ventilate_in_winter': ['living_area', 'number_of_rooms_in_the_flat', 'number_of_rooms_that_are_ventilated', 'building_year', 'energy_source'],
    'install_electronic_thermostats': ['room_size', 'building_year', 'energy_source'],
    'wash_your_hands_with_cold_water': ['number_of_hands_washing_per_day', 'energy_source'],
    'cooking_with_pot_lid_that_fits': ['meals_cooked_per_week'],
    'electric_water_heater_instead_of_an_electric_stove': ['water_heated_each_day'],
    'stove_off_before_food_is_ready': ['usages_per_week'],
    'do_not_preheat_the_oven': ['number_of_usages_per_month'],
    'dishwasher_instead_of_washing_up_by_hand': ['washing_dishes_per_week'],
    'purchase_an_energy_efficient_refrigerator': ['fridge_energy_class', 'fridge_type'],
    'housing_sufficiency': ['current_living_area', 'current_energy_source', 'new_living_area', 'new_energy_source'],
    'insulation': ['building_type', 'building_location', 'building_year', 'energy_source', 'roof_type', 'insulation_measure']
  }

  /**
   * Validates fields new_energy_source and current_energy_source for Minicheck Action 'housing_sufficiency'
   * Returns an error if both values are the same in case new and current living_area are the same too.
   */
  static validateEnergySource(): ValidatorFn {
    return(formGroup: FormGroup) => {
      // get some values from form input
      const currentLivingArea = formGroup?.controls?.current_living_area?.value;
      const newLivingArea = formGroup?.controls?.new_living_area?.value;
      const currentEnergySource = formGroup?.controls?.current_energy_source?.value;
      const newEnergySource = formGroup?.controls?.new_energy_source?.value;

      // return error if new and current values are the same
      if(currentEnergySource && newEnergySource && currentEnergySource === newEnergySource && currentLivingArea === newLivingArea) {
        return {sameEnergySource: false};
      }
      return null;
    }
  }

  /**
   * Validates Checkboxes, at least one checkbox has to be checked
   * Returns an error if no Checkbox is checked
   */
  static validateCheckboxesMinOneChecked(formConfig: EingabeForm): ValidatorFn {
    return (formGroup: FormGroup) => {
      // check only for action 'insulation'
      if (formConfig?.actionName === 'insulation') {
      // check if at least one checkbox is checked
      const isMinOneChecked = Object.keys(formGroup.value).some(key => formGroup.value[key] === true)
      // return error if not one checkbox is checked
      return isMinOneChecked ? null : {noCheckboxChecked: false};
      }
    }
  }

  /**
   * List of validators for the whole form. Can be used to validate between fields.
   * @protected
   */
  protected formValidators: ValidatorFn[] = [
    EingabeForm.validateEnergySource(),
    EingabeForm.validateCheckboxesMinOneChecked(this)
  ];

  /**
   * List of formvalidators and which fields should be marked as invalid
   * @protected
   */
  protected  formValidatorsFields: {[key: string]: string[]} = {
    sameEnergySource: ['current_energy_source', 'new_energy_source'],
    noCheckboxChecked: ['insulation_measure']
  };

  /**
   * List of formfields where changes of the value, change other fields.
   */
  fieldsForFormChanges: string[] = [
    'current_bio_product_proportion',
    'current_nutrition_style',
    'energy_source',
    'roof_type',
    'insulation_measure'
  ];

  /**
   *   Genereated the initial options for the field target_bio_product_proportion, begins with the next higher option
   *   @param currentValue
   */
  initOptionsTargetBioProductProportion(currentValue: number): string[] {
    return MinicheckContants.PERCENT_OPTIONS.filter(option => parseInt(option) > currentValue);
  }

  /**
   *   Updates Options for the field target_bio_product_proportion based on the current value of the field current_bio_product_proportion
   *   @param options
   *   @param current
   */
  updateOptionsTargetBioProductProportion(options: any, current: number) {
    return options.filter((target: number) => target > current);
  }

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: { [key: string]: any}): any {
    this.updateOptionsTargetBioProductProportion(MinicheckContants.PERCENT_OPTIONS, values.current_bio_product_proportion);

    // set options of target_bio_product_proportion higher than input to current_bio_product_proportion
    if(values.hasOwnProperty('current_bio_product_proportion')) {
      const currentOptions = this.initOptionsTargetBioProductProportion(values.current_bio_product_proportion);

      //set options for field target_bio_product_proportion dynamically
      if(currentOptions.length > 0) {
        this.activateField('target_bio_product_proportion');
        this.activateField('current_bio_nutrition_style');
        this.setOptions('target_bio_product_proportion', currentOptions);
        this.setOptions('current_bio_nutrition_style', MinicheckContants.NUTRITION_STYLE_OPTIONS);
      }
      else {
        //deactivate fields if there are no options for target_bio_product_proportion and set value to null
        this.deactivateField('target_bio_product_proportion');
        this.deactivateField('current_bio_nutrition_style');
        this.setOptions('target_bio_product_proportion', []);
        this.setOptions('current_bio_nutrition_style', []);
      }
    }

    // set options of target_nutrition_style with next higher index of current_bio_product_proportion input value
    if (values.hasOwnProperty('current_nutrition_style')) {
      const currentIndex = MinicheckContants.NUTRITION_STYLE_OPTIONS.indexOf(values.current_nutrition_style);
      const nextIndex = currentIndex < MinicheckContants.NUTRITION_STYLE_OPTIONS.length - 1 ? currentIndex + 1 : currentIndex;

      //set options for target_nutrition_style
      if (nextIndex != currentIndex) {
        this.activateField('target_nutrition_style');
        this.activateField('number_of_migrators');
        this.setOptions('target_nutrition_style', MinicheckContants.NUTRITION_STYLE_OPTIONS.slice(nextIndex));

        // preset value of number_of_migrators after reactivating field
        if (values.number_of_migrators === null) {
         this.form?.get('number_of_migrators')?.setValue(1, { emitEvent: false });
        }
      }
      else {
        //in case there is no next index, deactivate next fields and set value to null
        this.deactivateField('target_nutrition_style');
        this.deactivateField('number_of_migrators');
        this.setOptions('target_nutrition_style', []);
        this.setOptions('number_of_migrators', []);

        // reset values of other fields
        this.form?.get('target_nutrition_style')?.setValue('', { emitEvent: false});
        this.form?.get('number_of_migrators')?.setValue(null, { emitEvent: false});
      }
    }

    // action insulation
    if (this.actionName === 'insulation') {
      // set different options for energy source
      if (values.hasOwnProperty('energy_source')) {
        this.setOptions('energy_source', MinicheckContants.ENERGY_SOURCE_OPTIONS_BUILDING);
      }

      // set initial values for checkboxes from null to false to avoid form errors
      MinicheckContants.INSULATION_MEASURE_OPTIONS.forEach(option => {
        if (this.form.get('insulation_measure_' + option)?.value === null) {
          this.form.get('insulation_measure_' + option)?.setValue(false);
        }
      });

      // de/activate following fields if building_year is after_2001
      if (values.building_year === 'after_2001') {
        this.deactivateField('roof_type');
        this.deactivateField('energy_source');
        this.deactivateField('insulation_measure');

        // reset values for deactivated fields
        this.getField('energy_source').setValue([]);
        this.form?.controls['energy_source']?.setValue([], { emitEvent: false });
        this.form?.controls['roof_type']?.setValue(null, { emitEvent: false });

        // reset values for checkboxes
        for (const option of MinicheckContants.INSULATION_MEASURE_OPTIONS) {
          this.form?.controls['insulation_measure_' + option]?.setValue(false, { emitEvent: false });
        }
      }
      else {
        // activate fields
        this.activateField('roof_type');
        this.activateField('energy_source');
        this.activateField('insulation_measure');
      }

      // depending on roof_type we disable one of the insulation measures
      if (values.hasOwnProperty('roof_type') && this.getField('insulation_measure')?.isActive()) {
        // disable 'geschossdecke'
        if (values.roof_type === 'ausgebaut' || values.roof_type === 'flachdach') {
          this.getField('insulation_measure').setOptionsDisabled(['geschossdecke']);

          // reset values if 'geschossdecke' is selected and disabled at the same time
          if (this.getField('insulation_measure').isOptionDisabled('geschossdecke') && values.insulation_measure_geschossdecke !== false) {
            this.form?.get('insulation_measure_geschossdecke')?.setValue(false, { emitEvent: false });
          }
        }
        // disable 'dach'
        if (values.roof_type === 'nicht_ausgebaut') {
          this.getField('insulation_measure').setOptionsDisabled(['dach']);

          // reset values if 'dach' is selected and disabled at the same time
          if (this.getField('insulation_measure').isOptionDisabled('dach') && values.insulation_measure_dach !== false) {
            this.form?.get('insulation_measure_dach')?.setValue(false, { emitEvent: false });
          }
        }
      }
    }

  }


  /**
   * In this function all dynamic changes of the form is done.
   * Based on selection options or value other fields are shown/hidden, options changed and validators adapted.
   *
   * @inheritDoc
   * @param values
   * @protected
   */
  protected onSetData(values: { [key: string]: any }): void {
    this.updateFields(values);
  }

  /**
   * Save the data.
   * @param data
   */
  protected saveData(data: {[key: string]: any}): void {}

  /**
   * @inheritDoc
   * @protected
   */
  protected onChange() {
    // check if the form has some fields which value changes other fields.
    if (this.fieldsForFormChanges.find(field => this.form.get(field)) !== undefined) {
      const newValues = this.updateFields(this.getData());
      if(this.eingabeform) {
        this.eingabeform.saveData(newValues);
      }
    }
  }

  /**
   * sets the current action name of the minicheck
   * @param actionName
   */
  setActionName(actionName: string): void {
    this.actionName = actionName;
  }

}
